import { render, staticRenderFns } from "./GovernmentReceipt.vue?vue&type=template&id=3201647e&scoped=true&"
import script from "./GovernmentReceipt.vue?vue&type=script&lang=js&"
export * from "./GovernmentReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3201647e",
  null
  
)

export default component.exports